import { scale } from "@productlane/lib"

import { useRequiredPlans } from "@/lib/plans"
import { useRole } from "@/lib/useRole"
import { useZeroWorkspace } from "@/lib/zero"

export function useSlaFeatureEnabled(): boolean {
	const workspace = useZeroWorkspace()
	const { role } = useRole()
	const enabled =
		useRequiredPlans(scale.andUp) &&
		role !== "VIEWER" &&
		!!workspace?.slaEnabled

	return enabled
}
